import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { motion, AnimatePresence } from "framer-motion";
import { bool, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import Icon from "@components/shared/Icons/Icon";
import Radio from "@components/shared/Radio";
import Typography from "@components/shared/Typography";

import { Trans, useTranslation } from "@lib/i18n";

const CustomerConsentsItem = props => {
  const { consent, isReadOnly } = props;
  const [isOpen, setIsOpen] = useState(!isReadOnly);

  const { t } = useTranslation();

  const {
    clearErrors,
    control,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    setIsOpen(!isReadOnly);
  }, [isReadOnly]);

  return (
    <div className="flex flex-col gap-4 w-full">
      <div
        className={twMerge(
          "flex justify-start items-center gap-2",
          isReadOnly && "cursor-pointer select-none"
        )}
        onClick={() => isReadOnly && setIsOpen(!isOpen)}
      >
        {isReadOnly && (
          <Icon
            className="size-4 text-greyDark"
            icon={isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          />
        )}
        <Typography className="font-semibold">
          <Trans i18nKey={`myDetails.consents.${consent}.title`} />
        </Typography>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            animate={"open"}
            initial={"collapsed"}
            exit="collapsed"
            style={{ overflow: "hidden" }}
            variants={{
              open: { opacity: 1, height: "auto", pointerEvents: "initial" },
              collapsed: { opacity: 0, height: 0, pointerEvents: "none" },
            }}
            transition={{ duration: 0.3 }}
          >
            <Typography className="text-sm">
              <Trans
                components={{
                  a: (
                    <a
                      className="text-primaryOrange underline"
                      target="_blank"
                    />
                  ),
                }}
                i18nKey={`myDetails.consents.${consent}.text`}
              />
            </Typography>
          </motion.div>
        )}
      </AnimatePresence>
      <Controller
        control={control}
        name={`consents.${consent}`}
        render={({ name, onChange, value }) => (
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-start">
            <Radio
              className="[&_p]:text-sm [&>div>span]:mr-2"
              disabled={isReadOnly}
              label={t("myDetails.consents.agree")}
              name={name}
              onChange={e => {
                clearErrors(name);
                onChange(e);
              }}
              checked={String(value) === "true"}
              value={true}
            />
            <Radio
              className="[&_p]:text-sm [&>div>span]:mr-2"
              disabled={isReadOnly}
              label={t("myDetails.consents.decline")}
              name={name}
              onChange={e => {
                clearErrors(name);
                onChange(e);
              }}
              checked={String(value) === "false"}
              value={false}
            />
          </div>
        )}
      />
      {!!errors?.consents?.[consent] && (
        <Typography className="text-red text-sm">
          <Trans i18nKey={"myDetails.consents.error"} />
        </Typography>
      )}
    </div>
  );
};

CustomerConsentsItem.propTypes = {
  consent: string,
  isReadOnly: bool,
};

export default CustomerConsentsItem;
